<template>
  <div class="airlines">
    <adx-sidebar />
    <div class="container-router">
      <!-- Hidden for a while until other channel ready. -->
      <!-- <adx-sub-menubar :listUrl="subMenuList" /> -->
      <adx-jumbotron
      :image="jumbotronImg"
      :image-mobile="jumbotronImgMobile"
      :title="'Airlines Advertising'"
      :smallTitle="'ADX ASIA'"/>
      <div class="airlines__collections">
        <div class="airlines__collections__title">
          <h2 class="airlines__collections__title__subtitle small-title">Best Placement for your Advertisement</h2>
        </div>
        <p class="airlines__collections__subtitle">Advertising and marketing campaigns are easy, but engaging with consumers can be difficult. So what? Leverage existing partnerships for something bigger</p>
        <div v-if="isLoadingCol" class="package-wrapper-load">
          <adx-loading />
        </div>
        <div v-else class="airlines__collections__cardslider__content-doc">
          <collection-card v-for="(category, index) in airlinesCategory" 
            :key="index" :img="category.img" :title="category.title" :price="category.price" :description="category.description" :link="category.link"/>
        </div>
      </div>
      <div v-if="isLoadingCol">
        <adx-loading />
      </div>
      <div v-else v-for="(group, index) in collectionGroups" :key="index"
        class="airlines__collections">
        <div class="airlines__collections__title">
          <h2 class="airlines__collections__title__subtitle small-title">{{group.title}}</h2>
          <span @click.stop="allCollection(group.id)" class="mobile-ic-right"><i class="adx-ic_chevron_right"></i></span>
          <button class="link desktop" @click.stop="allCollection(group.id)">
             See all
            <span class="ic-right"><i class="adx-ic_chevron_right"></i></span></button>
        </div>
        <p v-if="group.description" class="airlines__collections__subtitle">{{group.description}}</p>
        <div v-if="isLoadingCol" class="package-wrapper-load">
          <adx-loading />
        </div>
        <div v-else class="airlines__collections__cardslider">
          <adx-card-slider
          :data="group.list"
          :slide="4"
          :slideMobile="2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar/Desktop'
import SubMenuBar from '@/components/SubMenuBar'
import Jumbotron from '@/components/Jumbotron/Category'
import CategoryCard from '@/components/Card/CategoryCard'
import CardSlider from '@/components/Slider/CardSlider'
import Media from "vue-media"
import Loading from '@/components/Loading/Primary'
import CollectionCard from '@/components/Card/CollectionCard'
import api from '@/api/'
import { apiV2 } from '@/api/urls'

export default {
  name: "adx-digital-screens",
  components: {
    "adx-jumbotron": Jumbotron,
    "adx-sidebar": SideBar,
    "adx-category-card": CategoryCard,
    "adx-card-slider": CardSlider,
    "adx-sub-menubar": SubMenuBar,
    'adx-loading': Loading,
    "media": Media,
    "collection-card": CollectionCard
  },
  head: {
    title: {
      inner: 'Digital Screen',
    }
  },
  created() {
    let file = `/static/data/menus.json`;
    (async () => {
      let request = await fetch(new Request(file));
      let data = await request.json();

      this.subMenuList = data.channels;
    })();
    this.getCollections()
  },
  data() {
    return {
      jumbotronImg: '/img/airlines/banner-airlines.jpg',
      jumbotronImgMobile: '/img/airlines/banner-airlines.jpg',
      showMore: false,
      subMenuList: [],
      isLoadingCol: true,
      collectionTitle: '',
      collectionDesc: '',
      airlinesCategory: [
        {
          title: 'Airport Media',
          img: '/img/airlines/Airport_media.png',
          link: '/airlines/airport-media',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',
        },
        {
          title: 'Inflight Avod',
          img: '/img/airlines/Inflight_avod.png',
          link: '/airlines/inflight/?category=AV',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',   
        },
        {
          title: 'Material Branding',
          img: '/img/airlines/Material_branding.png',
          link: '/airlines/inflight/?category=MB',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',
        },
        {
          title: 'Aircraft Livery',
          img: '/img/airlines/Livery.png',
          link: '/airlines/inflight/?category=AL',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',
        },
        {
          title: 'Inflight Magazine',
          img: '/img/airlines/magazine.png',
          link: '/airlines/inflight/?category=MZ',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',          
        },
        {
          title: 'Product Sampling',
          img: '/img/airlines/sampling.png',
          link: '/airlines/inflight/?category=SL',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',
        },
        {
          title: 'Airlines Office',
          img: '/img/airlines/office.png',
          link: '/airlines/inflight/?category=OF',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',
        },
        {
          title: 'Wifi Landing Page',
          img: '/img/airlines/wifi_landing_page.png',
          link: '/airlines/inflight/?category=WF',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.',
        },
      ],
      collectionsSlider: [
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/airport_lounge.jpg',
          title: 'Airport',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/gym.jpg',
          title: 'Sport Area',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/office_building.jpg',
          title: 'Office Building',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        }
      ],
      collectionGroups: []
    }
  },
  methods: {
    toggleMore() {
      this.showMore = !this.showMore
    },
    getCollections() {
      (async () => {
        this.isLoadingCol = true
        this.collectionGroups = []
        // const { data } = await api.get(apiV2.collectionAdvertiserList('digitalscreen'), { needToken: false })
        // this.collectionGroups = data.data.map(col => {
        //   return {
        //     ...col,
        //     list: col.list.map(item => {
        //       return {
        //         ...item,
        //         img: col.layout_id == 'RE' ? item.square_thumbnail : item.landscape_thumbnail
        //       }
        //     })
        //   }
        // })
        this.isLoadingCol = false
      })();
    },
    allCollection(id) {
      this.$router.push({ name: 'collectioncategory', params: { category: id } })
    }
  },
  computed: {
    btnCategoryText() {
      return (this.showMore ? 'View Less' : 'View More')
    }
  }
}
</script>

<style lang="scss">
@import "./index.scss";

.airlines{
  .container-router{

    .categoryJumbotron{
      margin-bottom: 48px;
    }

    .categoryJumbotron__image{
      &__layer{
        //  background-image: linear-gradient(to right, #ffffff, rgba(255, 255, 255, 0));
         &__content{
           i{
             display: none;
           }
         }
      }
      background-position-x: 0px;
    }
  }
}

.airlines__collections__cardslider__content-doc , .airlines__collections__cardslider {

  .collectionCard__title span{
    font-size: 17px;
    font-weight: bold
  }

  .collectionCard__description{
    font-size: 15px;
  }
}

@include breakpoint(md){
  .airlines{
    .container-router{

      .categoryJumbotron__image-mobile{
        max-height: 160px;
      }
    }
  }

  .airlines__collections__title__subtitle {
    font-size: 19px;
  }
}
</style>
